import { handleResponse } from './default'

const base = process.env.CQE_BASE_URL || '';
const httpContentType = 'application/json; charset=utf-8';
const headers = {
    'sso-service': 'AM.LOGIN'
};

const apiGet = path => fetch(base + path, {
        credentials: 'include',
        headers
    })
    .then(handleResponse);

const apiPost = (path,body) => fetch(base + path, {
        method: 'post',
        body: JSON.stringify(body),
        credentials: 'include',
        headers: {
            'Content-Type': httpContentType,
            ...headers
        }
    })
    .then(handleResponse);

function setHeader(key, val) {
    headers[key] = val;
    console.debug('setting cqe headers:', headers);
    return headers;
}

function getService(url, payload) {
    let params = 'platform=web&';
    for (const prop in payload) {
        params += `${prop}=${payload[prop]}&`;
    }
    return apiGet(`/${url}?${params}`);
}

function postService(url, payload) {
    const data = {
        platform: 'web',
        ...payload
    };
    return apiPost(`/${url}`, data);
}

function getLqdTrade(payload) {
    return getService('explain_liquidation_trades', payload);
}

const cqeApi = {
    getLqdTrade,
    getService,
    postService,
    setHeader
}

window.cqeApi = cqeApi;

export default cqeApi;
